import { UntypedFormControl, UntypedFormGroup } from "@angular/forms"
import { Profile } from "../shared/profile"

export class PersonalInformationForm extends UntypedFormGroup {

    constructor(profile: Profile) {
        super({
            'phone': new UntypedFormControl({value: profile.phone, disabled: true},
                []
            ),
            'email': new UntypedFormControl({value: profile.email, disabled: true},
                []
            ),
        })
    }
}
